import React from "react";
import { EmployeeClassificationsContainer } from "../../containers";

const EmployeeClassifications = (props) => {
  return <EmployeeClassificationsContainer {...props} />;
};

export default EmployeeClassifications;
